import { render, staticRenderFns } from "./WorkforceDetail.vue?vue&type=template&id=fc00f9b6&"
import script from "./WorkforceDetail.vue?vue&type=script&lang=js&"
export * from "./WorkforceDetail.vue?vue&type=script&lang=js&"
import style0 from "./WorkforceDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports